import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    --primary-blue: #4A90E2;
    --secondary-blue: #5C6BC0;
    --dark-blue: #1A365D;
    --light-blue: #EBF5FF;
    --white: #FFFFFF;
    --light-gray: #F5F7FA;
    --medium-gray: #8C9BAB;
  }

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
    line-height: 1.6;
    color: var(--dark-blue);
    background-color: var(--white);
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
    margin-bottom: 1rem;
    color: var(--dark-blue);
  }

  h1 {
    font-size: 3.5rem;
    line-height: 1.2;
  }

  h2 {
    font-size: 2.5rem;
    line-height: 1.3;
  }

  h3 {
    font-size: 1.8rem;
    line-height: 1.4;
  }

  p {
    margin-bottom: 1rem;
  }

  a {
    color: var(--primary-blue);
    text-decoration: none;
    transition: color 0.3s ease;
    
    &:hover {
      color: var(--secondary-blue);
    }
  }

  button {
    cursor: pointer;
    font-family: 'Montserrat', sans-serif;
  }

  section {
    padding: 5rem 0;
  }

  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1.5rem;
  }

  @media (max-width: 768px) {
    h1 {
      font-size: 2.5rem;
    }
    
    h2 {
      font-size: 2rem;
    }
    
    h3 {
      font-size: 1.5rem;
    }
    
    section {
      padding: 3rem 0;
    }
  }
`;

export default GlobalStyles;
